import React from 'react';

// Create a Context
const UserContext = React.createContext({
    userProfile: null,
    setUserProfile: (userProfile) => {}
});

export default UserContext;
